export default __webpack_public_path__ + "static/media/0068.48df1173.jpg";